var styles = {"container":"AppQRPromotion-module_container__2a4Df","title":"AppQRPromotion-module_title__1guif","caption":"AppQRPromotion-module_caption__qKvF4","highlight":"AppQRPromotion-module_highlight__3aMjl"};

export { styles as default };
//# sourceMappingURL=AppQRPromotion.module.css.js.map
